import React from 'react'

type FormProps = {
   onSubmit: React.FormEventHandler<HTMLFormElement>
   className?: string
   children: React.ReactNode
}
export const Form = ({ onSubmit, className, children }: FormProps) => {
   return (
      <form noValidate className={className ?? ''} onSubmit={onSubmit}>
         {children}
      </form>
   )
}
